import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as BaseIngredientList from 'types/_general/Store/BaseIngredientList';

const rb = new ReducerBuilder<BaseIngredientList.Type>();
export const createBaseIngredientListLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'BaseIngredientList/LoadedFromBackend'
);

export const baseIngredientListReducer = rb.createReducer();
